import React from "react";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@bigbinary/neeto-atoms/primitives";
import classNames from "classnames";
import { withT } from "neetocommons/react-utils";
import { hyphenize } from "neetocommons/utils/general";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Breadcrumbs = withT(
  ({ t, breadcrumbs = [], hasTrailingSeparator = false, className }) => (
    <Breadcrumb
      aria-label={t("neetoMolecules.breadcrumbs.breadcrumbAriaLabel")}
      className={classNames("mb-4", className)}
    >
      <BreadcrumbList>
        {breadcrumbs.map(({ text, link = "#" }, index) => {
          const isLast = index + 1 === breadcrumbs.length;
          const isCurrentPage = isLast && !hasTrailingSeparator;

          return (
            <React.Fragment key={index}>
              <BreadcrumbItem data-testid="header-breadcrumb">
                {isCurrentPage ? (
                  <BreadcrumbPage data-testid={`${hyphenize(text)}-breadcrumb`}>
                    {text}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link
                      data-testid={`${hyphenize(text)}-breadcrumb`}
                      to={link}
                    >
                      {text}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isCurrentPage && <BreadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
);

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default Breadcrumbs;
